define([
    'tpaGalleries/galleries/masonry',
    'tpaGalleries/galleries/accordion',
    'tpaGalleries/galleries/impress',
    'tpaGalleries/galleries/freestyle',
    'tpaGalleries/galleries/collage',
    'tpaGalleries/galleries/honeycomb',
    'tpaGalleries/galleries/stripShowcase',
    'tpaGalleries/galleries/stripSlideshow',
    'tpaGalleries/galleries/thumbnails',
    'tpaGalleries/galleries/tpa3DGallery',
    'tpaGalleries/galleries/tpa3DCarousel',
    'componentsCore',
    'skins',
    'tpaGalleries/skins/skins.json'
], function (
    masonry,
    accordion,
    impress,
    freestyle,
    collage,
    honeycomb,
    stripShowcase,
    stripSlideshow,
    thumbnails,
    tpa3DGallery,
    tpa3DCarousel,
    componentsCore,
    skinsPackage,
    skinsJson
) {
    'use strict';

    const tpaGalleries = {
        masonry,
        accordion,
        impress,
        freestyle,
        collage,
        honeycomb,
        stripShowcase,
        stripSlideshow,
        thumbnails,
        tpa3DGallery,
        tpa3DCarousel
    };

    componentsCore.compRegistrar.register('tpa.viewer.components.Masonry', tpaGalleries.masonry)
        .register('tpa.viewer.components.Accordion', tpaGalleries.accordion)
        .register('tpa.viewer.components.Impress', tpaGalleries.impress)
        .register('tpa.viewer.components.Freestyle', tpaGalleries.freestyle)
        .register('tpa.viewer.components.Collage', tpaGalleries.collage)
        .register('tpa.viewer.components.Honeycomb', tpaGalleries.honeycomb)
        .register('tpa.viewer.components.StripShowcase', tpaGalleries.stripShowcase)
        .register('tpa.viewer.components.StripSlideshow', tpaGalleries.stripSlideshow)
        .register('tpa.viewer.components.Thumbnails', tpaGalleries.thumbnails)
        .register('wysiwyg.viewer.components.tpapps.TPA3DGallery', tpaGalleries.tpa3DGallery)
        .register('wysiwyg.viewer.components.tpapps.TPA3DCarousel', tpaGalleries.tpa3DCarousel);

    skinsPackage.skinsMap.addBatch(skinsJson);

    return tpaGalleries;
});
